import { PATH_LOGIN } from '../navigation/navigation.module';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (localStorage.getItem('token')) {
            return true;
        }

        this.router.navigate([PATH_LOGIN], { queryParams: { returnUrl: state.url }});
        return false;
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/guards/auth-guard.ts